import { IconProps } from "@/icons/icon";
import { rem } from "@mantine/core";
import { memo } from "react";

export const MagnifyingGlassPlus = memo(function MagnifyingGlassPlus({
  size = 16,
  style,
  ...others
}: IconProps) {
  return (
    <svg
      style={{ width: rem(size), height: rem(size), ...style }}
      {...others}
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        className="fa-secondary"
        opacity=".4"
        d="M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm96 0c0-13.3 10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24z"
      />
      <path
        className="fa-primary"
        d="M184 296l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24zM457.4 502.6L330.7 376C348 363.3 363.3 348 376 330.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"
      />
    </svg>
  );
});
